const u = up.util;
const e = up.element;
up.Change.Addition = class Addition extends up.Change {
    constructor(options) {
        super(options);
        this._acceptLayer = options.acceptLayer;
        this._dismissLayer = options.dismissLayer;
        this._eventPlans = options.eventPlans || [];
        this._response = options.response;
    }
    handleLayerChangeRequests(newElements, newLocation) {
        if (this.layer.isOverlay()) {
            this._tryAcceptLayerFromServer();
            this.layer.assertAlive();
            this.layer.tryAcceptForLocation(newLocation, this._response);
            this.layer.assertAlive();
            this.layer.tryAcceptForElements(newElements, this._response);
            this.layer.assertAlive();
            this._tryDismissLayerFromServer();
            this.layer.assertAlive();
            this.layer.tryDismissForLocation(newLocation, this._response);
            this.layer.assertAlive();
            this.layer.tryDismissForElements(newElements, this._response);
            this.layer.assertAlive();
        }
        this.layer.asCurrent(() => {
            for (let eventPlan of this._eventPlans) {
                up.emit(Object.assign(Object.assign({}, eventPlan), { response: this._response }));
                this.layer.assertAlive();
            }
        });
    }
    _tryAcceptLayerFromServer() {
        if (u.isDefined(this._acceptLayer)) {
            this.layer.accept(this._acceptLayer, { response: this._response });
        }
    }
    _tryDismissLayerFromServer() {
        if (u.isDefined(this._dismissLayer)) {
            this.layer.dismiss(this._dismissLayer, { response: this._response });
        }
    }
    _setSource({ oldElement, newElement, source }) {
        if (source === 'keep') {
            source = (oldElement && up.fragment.source(oldElement));
        }
        if (source) {
            e.setMissingAttr(newElement, 'up-source', up.fragment.normalizeSource(source));
        }
    }
    _setTime({ newElement, time }) {
        e.setMissingAttr(newElement, 'up-time', time ? time.toUTCString() : false);
    }
    _setETag({ newElement, etag }) {
        e.setMissingAttr(newElement, 'up-etag', etag || false);
    }
    setReloadAttrs(options) {
        this._setSource(options);
        this._setTime(options);
        this._setETag(options);
    }
    executeSteps({ steps, responseDoc, noneOptions }) {
        return new up.Change.UpdateSteps({ steps, noneOptions }).execute(responseDoc);
    }
};
